import { Box } from "@mui/material";
import styled from "styled-components";

export const IconContainer = styled(Box)`
    cursor:pointer;
`